import * as types from 'store/actions/types';

const INITIAL_STATE = {
	loading: false,
	error: false,
	data: []
};

export default function(state = INITIAL_STATE, action = {}) {
	switch (action.type) {
		case types.RECOMMENDATIONS_LOADING:
			return {
				...state,
				loading: true,
				error: false
			};
		case types.RECOMMENDATIONS_SUCCESS:
			return {
				...state,
				loading: false,
				error: false,
				data: action.payload
			};
		case types.RECOMMENDATIONS_ERROR:
			return {
				...state,
				loading: false,
				error: true
			};
		case types.RECOMMENDATIONS_CLEAR:
			return INITIAL_STATE;
		default:
			return state;
	}
}
